/* eslint-disable jsx-a11y/no-autofocus */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useState } from 'react';
import { toast } from 'react-toastify';
import { EMAIL_REGEX } from '@Saral-Influencer-Marketing/saral-utils/dist/constants/regex';
import { formatRefUrl } from '@Saral-Influencer-Marketing/saral-utils/dist/functions/profiles/socialLinks';
import { Button, Heading, Text } from '../../styledComponents';
import { updateCreatorDetails } from '../../../services/dashboard.service';
import AddressUpdateModal from '../addressUpdateModal/AddressUpdateModal';
// import PaymentHistoryModal from '../paymentHistoryModal/PaymentHistoryModal';
// import copyIcon from '../../../assets/icons/copy.svg';
import EditIcon from '../../../assets/icons/EditIcon';
import PaypalIcon from '../../../assets/icons/paypal.svg';
import styles from './DetailsCard.module.css';
import EditDiscountCodeModal from '../editDiscountModal/EditDiscountCodeModal';
import { formatCurrency, formatRefLink } from '../../../utils/global';
import ChangePasswordModal from '../changePasswordModal/ChangePasswordModal';
import CustomTooltip from '../../common/CustomTooltip/CustomTooltip';

type DetailsCardPropsType = {
  profileId: string;
  fullName: string;
  trackingLink: string;
  couponCode: any;
  commission: number;
  email: string;
  paypalEmail: string;
  address: any;
  affiliateId: number;
  trackingLinks: {
    _id: string;
    refLink: string;
    refCode: string;
  }[];
  fetchHomePageData: () => void;
  refCode: string;
  userName: string;
  platform: string;
  dynamicDiscountEnabled?: boolean;
  isNonAffiliate?: boolean;
  totalSubmissions: number;
  totalPayments: number;
  defaultCurrency: string;
};

type CouponType = {
  code: string;
  type: string;
  discount_value: number;
  discount_type: string;
  can_change: boolean;
};

export default function DetailsCard({
  profileId,
  fullName,
  trackingLink,
  couponCode,
  commission,
  email,
  address,
  trackingLinks,
  paypalEmail,
  affiliateId,
  // defaultCurrency,
  refCode,
  fetchHomePageData,
  userName,
  platform,
  dynamicDiscountEnabled,
  isNonAffiliate,
  totalSubmissions,
  totalPayments,
  defaultCurrency,
}: DetailsCardPropsType) {
  const [showUpdateAddressModal, setShowUpdateAddressModal] = useState<boolean>(false);
  // const [showPaymentHistoryModal, setShowPaymentHistoryModal] = useState<boolean>(false);
  const [editEmail, setEditEmail] = useState<boolean>(false);
  const [editPaypalEmail, setEditPaypalEmail] = useState<boolean>(false);
  const [editName, setEditName] = useState<boolean>(false);

  const [editEmailText, setEditEmailText] = useState<string>('');
  const [editPaypalEmailText, setEditPaypalEmailText] = useState<string>('');
  const [editNameText, setEditNameText] = useState<string>('');

  const [showEditDiscountCodeModal, setShowEditDiscountCodeModal] = useState<boolean>(false);
  const [selectedDiscountCode, setSelectedDiscountCode] = useState<CouponType | null>(null);
  const [showChangePasswordModal, setShowChangePasswordModal] = useState<boolean>(false);

  const copyText = (text: string, message: string) => {
    navigator.clipboard.writeText(text);
    toast.success(message || 'Link Copied!');
  };

  const getFormattedAddressString = (addresses: any) => {
    if (addresses === undefined) return 'N/A';
    if (addresses && addresses?.length === 0) return 'NA';
    const { addressLineOne, addressLineTwo, city, state, country, pincode } = addresses[addresses.length - 1];
    return `${addressLineOne}, ${addressLineTwo ? `${addressLineTwo},` : ''} ${city}, ${state}, ${country}, ${pincode}`;
  };

  const handleEmailUpdate = async () => {
    if (EMAIL_REGEX.test(editEmailText.trim())) {
      const response = await updateCreatorDetails(profileId, { email: editEmailText });
      if (response.status) {
        setEditEmail(false);
        setEditEmailText('');
        toast.success('Email updated successfully!');
        fetchHomePageData();
      }
    } else {
      toast.error('Incorrect Email, Please check!');
    }
  };

  const handlePaypalEmailUpdate = async () => {
    if (EMAIL_REGEX.test(editPaypalEmailText.trim())) {
      const response = await updateCreatorDetails(profileId, { paypalEmail: editPaypalEmailText });
      if (response.status) {
        setEditPaypalEmail(false);
        setEditPaypalEmailText('');
        toast.success('Paypal email updated successfully!');
        fetchHomePageData();
      }
    } else {
      toast.error('Incorrect Email, Please check!');
    }
  };

  const handleNameUpdate = async () => {
    const response = await updateCreatorDetails(profileId, { name: editNameText });
    if (response.status) {
      setEditName(false);
      setEditNameText('');
      toast.success('Name updated successfully!');
      fetchHomePageData();
    } else {
      toast.error('Error while updating name!');
    }
  };

  return (
    <>
      <div className={styles.detailsCard}>
        <div className={styles.cardSection}>
          <Heading as="h2" fontSize="24px" fontWeight="500" lineHeight="120%">
            My Details
          </Heading>
        </div>

        <div className={`${styles.cardSection} ${styles.emailSection}`}>
          <Text fontSize="14px">
            <span className={styles.title}>
              <span>🙋🏻‍♂️</span>
              <span>Full Name:</span>
            </span>
            {editName ? (
              <input autoFocus value={editNameText} onChange={(e) => setEditNameText(e.target.value)} />
            ) : (
              <div className={styles.text}>{fullName}</div>
            )}
          </Text>
          {editNameText ? (
            <Button className={styles.saveButton} onClick={handleNameUpdate}>
              Save
            </Button>
          ) : (
            <button
              type="button"
              className={styles.editButton}
              onClick={() => {
                setEditName(true);
                setEditNameText(fullName);
              }}
            >
              <EditIcon width={12} height={12} />
            </button>
          )}
        </div>

        {!isNonAffiliate && (
          <>
            <div className={styles.cardSection}>
              <Text fontSize="14px">
                <span className={styles.title}>
                  <span>🔗</span>
                  <span>Tracking Link: </span>
                </span>
              </Text>
              <div className={styles.linksContainer}>
                <span
                  className={styles.link}
                  onClick={() => {
                    const link = formatRefUrl(`https://${formatRefLink(trackingLink, refCode, platform, userName)}`);
                    copyText(link, 'Tracking link copied!');
                  }}
                >
                  {formatRefLink(trackingLink, refCode, platform, userName)}
                </span>
                {trackingLinks?.map(({ _id, refLink, refCode: rCode }: any) => (
                  <span
                    className={styles.link}
                    key={_id}
                    onClick={() =>
                      copyText(
                        `https://${formatRefLink(trackingLink, refCode, platform, userName)}`,
                        'Tracking link copied!'
                      )
                    }
                  >
                    {formatRefLink(refLink, rCode, platform, userName)}
                  </span>
                ))}
              </div>
            </div>
            <div className={styles.cardSection}>
              <Text fontSize="14px">
                <span className={styles.title}>
                  <span>🏷️</span>
                  <span>Discount Code: </span>
                </span>
                {couponCode?.length === 0 && !dynamicDiscountEnabled && 'No Discount Code Available'}
              </Text>
              <div className={styles.codesContainer}>
                {couponCode?.length > 0 &&
                  couponCode?.map((coupon: CouponType, index: number) => (
                    <span
                      className={styles.code}
                      key={index}
                      onClick={() => copyText(coupon.code, 'Coupon code copied!')}
                    >
                      {coupon.code}
                      <span
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowEditDiscountCodeModal(true);
                          setSelectedDiscountCode(coupon);
                        }}
                        style={{ display: 'grid', placeItems: 'center' }}
                      >
                        <EditIcon width={14} height={14} />
                      </span>
                    </span>
                  ))}
                {dynamicDiscountEnabled && (
                  <CustomTooltip title="The actual code is generated on site visit">
                    <span className={styles.dynamicCode}>
                      ⚡ DYNAMIC
                      <span style={{ display: 'grid', placeItems: 'center' }} />
                    </span>
                  </CustomTooltip>
                )}
              </div>
            </div>

            <div className={styles.cardSection}>
              <Text fontSize="14px">
                <span className={styles.title}>
                  <span>💸</span>
                  <span>Commission: </span>
                </span>
                <div className={styles.text}>{commission}</div>
              </Text>
            </div>
          </>
        )}

        <div className={`${styles.cardSection} ${styles.emailSection}`}>
          <Text fontSize="14px">
            <span className={styles.title}>
              <span>📨</span>
              <span>Email: </span>
            </span>
            {editEmail ? (
              <input autoFocus value={editEmailText} onChange={(e) => setEditEmailText(e.target.value)} />
            ) : (
              <div className={styles.text}>{email}</div>
            )}
          </Text>
          {editEmail ? (
            <Button className={styles.saveButton} onClick={handleEmailUpdate}>
              Save
            </Button>
          ) : (
            <button
              type="button"
              className={styles.editButton}
              onClick={() => {
                setEditEmail(true);
                setEditEmailText(email);
              }}
            >
              <EditIcon width={12} height={12} />
            </button>
          )}
        </div>

        <div className={`${styles.cardSection} ${styles.emailSection}`}>
          <Text fontSize="14px">
            <span className={styles.title}>
              <span>
                <img src={PaypalIcon} alt="" width={16} />
              </span>
              <span>Paypal Email: </span>
            </span>
            {editPaypalEmail ? (
              <input autoFocus value={editPaypalEmailText} onChange={(e) => setEditPaypalEmailText(e.target.value)} />
            ) : (
              <div className={styles.text}>{paypalEmail || 'N/A'}</div>
            )}
          </Text>

          {editPaypalEmail ? (
            <Button className={styles.saveButton} onClick={handlePaypalEmailUpdate}>
              Save
            </Button>
          ) : (
            <button
              type="button"
              className={styles.editButton}
              onClick={() => {
                setEditPaypalEmail(true);
                setEditPaypalEmailText(paypalEmail);
              }}
            >
              <EditIcon width={12} height={12} />
            </button>
          )}
        </div>

        <div className={`${styles.cardSection} ${styles.addressSection}`}>
          <Text fontSize="14px">
            <span className={styles.title}>
              <span>🏠</span>
              <span>Address: </span>
            </span>
            <div className={styles.text}>{getFormattedAddressString(address)}</div>
          </Text>
          <button type="button" className={styles.editButton} onClick={() => setShowUpdateAddressModal(true)}>
            <EditIcon width={12} height={12} />
          </button>
        </div>

        <div className={`${styles.cardSection} ${styles.changePasswordSection}`}>
          <Text fontSize="14px" className={styles.changePasswordLabel}>
            <span className={styles.title}>
              <span className={styles.sectionIcon}>🔑</span>
              <span>Password: </span>
            </span>
            <Text className={styles.passwordBox}>•••••••••••••••••••••••••••••••••••</Text>
          </Text>
          <button type="button" className={styles.editPasswordButton} onClick={() => setShowChangePasswordModal(true)}>
            Change Password
          </button>
        </div>

        <div className={styles.cardSection}>
          <Text fontSize="14px">
            <span className={styles.title}>
              <span>💿</span>
              <span>Total Submissions: </span>
            </span>
            <div className={styles.text}>{totalSubmissions || '--'}</div>
          </Text>
        </div>

        <div className={styles.cardSection}>
          <Text fontSize="14px">
            <span className={styles.title}>
              <span>💳</span>
              <span>Total Payments: </span>
            </span>
            <div className={styles.text}>{formatCurrency(totalPayments, defaultCurrency) || '--'}</div>
          </Text>
        </div>

        {/* <div className={styles.cardSection}>
          <Text fontSize="14px">
            <span className={styles.title}>
              <span >💵</span>
              <span>Payment History: </span>
            </span>
            <span
              style={{ color: 'var(--saral-purple)', cursor: 'pointer', fontWeight: 500 }}
              onClick={() => setShowPaymentHistoryModal(true)}
            >
              View
            </span>
          </Text>
        </div> */}
      </div>

      {showUpdateAddressModal && (
        <AddressUpdateModal
          address={address[address.length - 1]}
          setShowUpdateAddressModal={setShowUpdateAddressModal}
          fetchHomePageData={fetchHomePageData}
          profileId={profileId}
        />
      )}
      {showEditDiscountCodeModal && (
        <EditDiscountCodeModal
          selectedDiscountCode={selectedDiscountCode}
          setShowEditDiscountCodeModal={setShowEditDiscountCodeModal}
          fetchHomePageData={fetchHomePageData}
          profileId={profileId}
          affiliateId={affiliateId}
        />
      )}
      {showChangePasswordModal && (
        <ChangePasswordModal
          profileId={profileId}
          fetchHomePageData={fetchHomePageData}
          setShowChangePasswordModal={setShowChangePasswordModal}
        />
      )}
      {/* 
      {showPaymentHistoryModal && (
        <PaymentHistoryModal
          setShowPaymentHistoryModal={setShowPaymentHistoryModal}
          fullName={fullName}
          profileId={profileId}
          defaultCurrency={defaultCurrency}
        />
      )} */}
    </>
  );
}
